import PropTypes from 'prop-types';
import React from 'react';

import TeamSection from './TeamSection';

export default class SkirmishTeams extends React.Component {
  static propTypes = {
    data: PropTypes.object,
  };
  render() {
    const {data} = this.props;
    const {title, inviteIcon, inviteList, inviteText, perfList, highPerfText, perfIcon} = data;
    const initPerfList = perfList || [];
    const initInviteList = inviteList || [];
    return (
      <div className="skirmish-teams container">
        <div className="row">
          <div className="col-xs-12 text-center">
            <h1>{title}</h1>
          </div>
        </div>
        {initInviteList.length !== 0 ? (
          <div className="row">
            <div className="col-xs-12">
              <TeamSection invite title={inviteText} icon={inviteIcon} list={inviteList} />
            </div>
          </div>
        ) : null}
        {initPerfList.length !== 0 ? (
          <div className="row">
            <div className="col-xs-12">
              <TeamSection title={highPerfText} icon={perfIcon} list={perfList} />
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
